<!-- <div #supersetContainer id="superset-container" style="width: 200vh; height: 100vh"></div> -->



<!-- <div>
  <h1>Superset</h1>
</div>
<div id="superset-container" class="i-frame"></div> -->

<!-- <iframe
  #supersetContainer
  id="superset-container"
  width="100%"
  height="800"
  frameborder="0"
></iframe> -->



<div class="omni-sidebar">
  <button class="sidebar-btn" (click)="goHome()" title="Home">
    <mat-icon>arrow_back</mat-icon>
   
  </button>
  <button class="sidebar-btn" (click)="goBack()" title="Back">
     <mat-icon>home</mat-icon>
  </button>
</div>
<!-- <h1 class="tag">Omni Dashboard</h1> -->
<div class="omni-main">
  <div id="superset-container" class="i-frame"></div>
</div>